export default __webpack_public_path__ + "static/media/login-3938432_1920-1427x1024.94f24892.jpg";